export default () => {
  const stats = document.querySelectorAll('.c-stats--left');

  let currentParent = null;
  const groups = [];
  let currentGroup = [];

  [].forEach.call(stats, stat => {
    const parent = stat.parentNode;

    if (currentParent !== null && parent !== currentParent) {
      if (currentGroup.length > 1) {
        groups.push(currentGroup);
      }

      currentGroup = [];
    }

    if (stat.querySelector('.c-stats__label') !== null) {
      currentGroup.push(stat.querySelector('.c-stats__stat'));
      currentParent = parent;
    } else {
      if (currentGroup.length > 1) {
        groups.push(currentGroup);
      }
      currentGroup = [];
    }
  });

  if (currentGroup.length > 1) {
    groups.push(currentGroup);
  }

  if (groups.length < 1) {
    return;
  }

  function alignStats() {
    for (let i = 0; i < groups.length; i += 1) {
      let maxWidth = 0;

      for (let ii = 0; ii < groups[i].length; ii += 1) {
        const stat = groups[i][ii];
        stat.style.minWidth = 'auto';
        maxWidth = Math.max(maxWidth, stat.offsetWidth + 1);
      }

      for (let ii = 0; ii < groups[i].length; ii += 1) {
        const stat = groups[i][ii];
        stat.style.minWidth = `${maxWidth}px`;
      }
    }
  }

  alignStats();
  let resizeTimeout = null;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(alignStats, 200);
  });
  window.addEventListener('load', alignStats);
};



// WEBPACK FOOTER //
// ./src/scripts/modules/stats.js